import React, { useState, useCallback, useEffect, useMemo} from 'react';
import PropTypes from 'prop-types';
// @mui
import { Box, Grid, Card, Link, Typography, Stack, Button, Snackbar,Alert,TextField,InputAdornment, Divider   } from '@mui/material';
// import { styled } from '@mui/material/styles';
// utils
import { fCurrency } from '../../../utils/formatNumber';
// components
import Label from '../../../components/label';
import dayjs from 'dayjs';
import CardActions from '@mui/material/CardActions';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import axios, * as others from 'axios'
import Iconify from 'src/components/iconify/Iconify';
import { Modal as BaseModal } from '@mui/base/Modal';
import clsx from 'clsx';
import { styled, css } from '@mui/system';
import UndoIcon from '@mui/icons-material/Undo';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import config from "../../../config";
import { NumericFormat } from 'react-number-format';
import { Person } from '@mui/icons-material';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { FormProvider, RHFSelect, RHFSwitch, RHFTextField, RHFUploadAvatar } from 'src/components/hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
// ----------------------------------------------------------------------

const StyledProductImg = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute'
});

const currencies = [
  {
    value: 'USD',
    label: '$',
  },
  {
    value: 'EUR',
    label: '€',
  },
  {
    value: 'VND',
    label: '₫',
  },
  {
    value: 'JPY',
    label: '¥',
  },
];

// ----------------------------------------------------------------------

ShopProductCard.propTypes = {
  product: PropTypes.object,
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));


export default function ShopProductCard({ product, onCancelCompleted, customerCodes }) {
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string().required('Email is required').email(),
    phoneNumber: Yup.string().required('Phone number is required'),
    address: Yup.string().required('Address is required'),
    country: Yup.string().required('country is required'),
    company: Yup.string().required('Company is required'),
    state: Yup.string().required('State is required'),
    city: Yup.string().required('City is required'),
    role: Yup.string().required('Role Number is required'),
    avatarUrl: Yup.mixed().test('required', 'Avatar is required', (value) => value !== ''),
  });

  const defaultValues = useMemo(
    () => ({
      prepaidJpShippingFee: product?.prepaidJpShippingFee || '',
      vnWeight: product?.vnWeight || '300',
      customerCode: product?.customerCode || '',
      jpRate: product?.jpRate || '170',
      billCode: product?.billCode || '',
      surCharge1: product?.surCharge1 || '',
      paymentFee: product?.paymentFee || '100',
      serviceFee: product?.serviceFee || '2',
      status: product?.status,
      sellerName: product?.sellerName,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [product]
  );

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    watch,
    control,
    setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const values = watch();

  const onSubmit = async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      reset();
      enqueueSnackbar(!edit ? 'Create success!' : 'Update success!');
      // navigate(PATH_DASHBOARD.user.list);
    } catch (error) {
      console.error(error);
    }
  };

  const { productName, imageUrl, productPrice, productUrl, sellerName, billCode, productId, paymentDate, shippingStatus  } = product;
  const API_HOST = config.API_URL;
  const [message, setMessage] = useState ("");
  const [show, setShow] = useState(false);
  const editOrder = ()=>{

  }

  const cancelOrder = ()=>{
    const cancel_url = API_HOST+ "/api/orders/cancel";


    axios({
      method: 'post',
      url: cancel_url,
      headers: {}, 
      data: product
    }).then(function (response) {
      setMessage("Cancel order successfully!");
      setShow(true);
      setOpen(false);
      onCancelCompleted();

    }).catch((error) => {
      setOpen(false);
      setMessage("Cancel order failed!");
      setShow(true);
    }); 
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [edit, setEdit] = React.useState(false);
  const handleEditOpen = () => setEdit(true);
  const handleEditClose = () => setEdit(false);


  const Backdrop = React.forwardRef((props, ref) => {
    const { open, className, ...other } = props;
    return (
      <div
        className={clsx({ 'base-Backdrop-open': open }, className)}
        ref={ref}
        {...other}
      />
    );
  });
  
  Backdrop.propTypes = {
    className: PropTypes.string.isRequired,
    open: PropTypes.bool,
  };
  
  const blue = {
    200: '#99CCFF',
    300: '#66B2FF',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    700: '#0066CC',
  };
  
  const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
  };
  
  const Modal = styled(BaseModal)`
    position: fixed;
    z-index: 1300;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `;
  
  const StyledBackdrop = styled(Backdrop)`
    z-index: -1;
    position: fixed;
    inset: 0;
    background-color: rgb(0 0 0 / 0.5);
    -webkit-tap-highlight-color: transparent;
  `;
  
  const ModalContent = styled('div')(
    ({ theme }) => css`
      font-family: 'IBM Plex Sans', sans-serif;
      font-weight: 500;
      text-align: start;
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 8px;
      overflow: hidden;
      background-color: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
      border-radius: 8px;
      border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
      box-shadow: 0 4px 12px
        ${theme.palette.mode === 'dark' ? 'rgb(0 0 0 / 0.5)' : 'rgb(0 0 0 / 0.2)'};
      padding: 24px;
      color: ${theme.palette.mode === 'dark' ? grey[50] : grey[900]};
  
      & .modal-title {
        margin: 0;
        line-height: 1.5rem;
        margin-bottom: 8px;
      }
  
      & .modal-description {
        margin: 0;
        line-height: 1.5rem;
        font-weight: 400;
        color: ${theme.palette.mode === 'dark' ? grey[400] : grey[800]};
        margin-bottom: 4px;
      }
    `,
  );
  

  const NumericFormatCustom = React.forwardRef(
    function NumericFormatCustom(props, ref) {
      const { onChange, ...other } = props;
  
      return (
        <NumericFormat
          {...other}
          getInputRef={ref}
          onValueChange={(values) => {
            onChange({
              target: {
                name: props.name,
                value: values.value,
              },
            });
          }}
          thousandSeparator
          valueIsNumericString
        />
      );
    },
  );
  
  NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  // const [values, setValues] = React.useState({
  //   numberformat: product.prepaidJpShippingFee,
  // });

  const handleChange = (event) => {
    // setValues({
    //   ...values,
    //   [event.target.name]: event.target.value,
    // });
  };

  const steps = ['Thanh toán', 'Ship', 'Nhận hàng'];

 

  return (
    <div>
          <Card>
          <Box sx={{ pt: '50%', position: 'relative', height: '70%' }}>
              <Label
                variant="filled"
                // color={(status === 'sale' && 'error') || 'info'}
                color={'info'}
                sx={{
                  zIndex: 9,
                  top: 16,
                  right: 16,
                  position: 'absolute',
                  textTransform: 'uppercase',
                }}
              >
                {sellerName}
              </Label>
            <StyledProductImg alt={productName} src={imageUrl!=null?imageUrl.split("?")[0]:""} />
          </Box>

          <Stack spacing={2} sx={{ p: 3 }}>
            <Link href={productUrl} color="inherit" underline="hover" >
              <Typography variant="subtitle2" noWrap>
                {productName}
              </Typography>
            </Link>

            <Stack direction="row" alignItems="center" justifyContent="space-between">
              {/* <ColorPreview colors={colors} /> */}
              <Typography
                  component="span"
                  variant="body2"
                  sx={{
                  }}
                >
                  {dayjs(product.sucessfulAuctionDate).format('DD/MM/YYYY HH:mm')}
                </Typography >
              <Typography variant="subtitle2" color={'error'}>
                &nbsp;
                ¥{fCurrency(productPrice)}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Label
                    variant="filled"
                    color={((paymentDate==null||paymentDate==undefined) && 'error') || 'success'}
                    sx={{
                      zIndex: 9,
                      top: 16,
                      left: 16,
                      position: 'absolute',
                      textTransform: 'uppercase',
                    }}
                  >
                    {(paymentDate==null||paymentDate==undefined)? 'New': 'Paid'}
                  </Label>
                {billCode!=null?(<Label
                    variant="filled"
                    // color={(status === 'sale' && 'error') || 'info'}
                    color={'error'}
                    sx={{
                      zIndex: 9,
                      bottom: 16,
                      right: 16,
                      position: 'absolute',
                      textTransform: 'uppercase',
                    }}
                  >
                    {billCode}          
                  </Label>):<></>}
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <PersonOutlineIcon/>  
                        <Typography variant="subtitle2" >
                        {product.customerCode}
                       </Typography>
                      </Stack>
            </Stack>
          </Stack>
          <Divider/>
          <CardActions disableSpacing>
            <Grid container>
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Stack>
                            <IconButton aria-label="Cancel Order"  sx={{ color: 'error.main' }} onClick={()=>handleOpen()}>
                                    <Iconify icon={'eva:trash-2-outline'}  />
                        </IconButton> 
                        {shippingStatus==1?(<Iconify icon={'eva:car-fill'} color={'success'}/>):<></>} 
                      </Stack>
                      <Stack>
                        <IconButton aria-label="Update Order"  sx={{ color: 'info' }} onClick={()=>handleEditOpen()}>
                              <CreateOutlinedIcon/>
                        </IconButton> 
                      </Stack>
                    </Grid>
            </Grid>
            
          </CardActions>
        </Card>

{/* Edit Modal */}

            <BootstrapDialog
        onClose={handleEditClose}
        aria-labelledby="customized-dialog-title"
        open={edit}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Cập Nhật Đơn Hàng
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleEditClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Card sx={{ p: 3 }}>
                <Box
                  sx={{
                    display: 'grid',
                    columnGap: 2,
                    rowGap: 3,
                    gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
                  }}
                >
                  <RHFTextField name="jpRate" label="Tỷ giá JPY/VND" />
                  <RHFTextField name="vnWeight" label="Cân nặng (gram)" />
                  <RHFTextField name="prepaidJpShippingFee" label="Phí ship nội địa Nhật (JPY)" />

                  <RHFSelect name="customerCode" label="Mã KH" placeholder="Mã KH">
                    <option value="" />
                    {customerCodes.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </RHFSelect>

                  <RHFTextField name="paymentFee" label="Phí thanh toán (JPY)" />
                  <RHFTextField name="surCharge1" label="Phụ phí khác (VNĐ)" />
                  <RHFTextField name="serviceFee" label="Phí dịch vụ (%)" />
                  <RHFSelect name="status" label="Trạng thái" placeholder="Trạng thái">
                    <option value="" />
                      <option key='1' value='1'>
                        Chưa Thanh Toán
                      </option>
                      <option key='2' value='2'>
                        Đã Thanh Toán
                      </option>
                      <option key='3' value='3'>
                        Ship Nội Địa Nhật
                      </option>
                      <option key='4' value='4'>
                        Kho Nhật
                      </option>
                      <option key='5' value='5'>
                        Xuất Kho Nhật
                      </option>
                      <option key='6' value='6'>
                        Kho Việt
                      </option>
                      <option key='7' value='7'>
                        Xuất Kho Việt
                      </option>
                   
                  </RHFSelect>
                  <RHFTextField name="billCode" label="Mã vận đơn" />
                  <RHFTextField name="sellerName" label="Người Bán" />
                  {/* <RHFTextField name="zipCode" label="Zip/Code" />
                  <RHFTextField name="company" label="Company" />
                  <RHFTextField name="role" label="Role" /> */}
                </Box>

                <Stack alignItems="flex-end" sx={{ mt: 3 }}>
                  {/* <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                    {!edit ? 'Create User' : 'Save Changes'}
                  </LoadingButton> */}
                </Stack>
              </Card>
          </FormProvider>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleEditClose}>
            Cập Nhật
          </Button>
        </DialogActions>
      </BootstrapDialog>      


{/* Cancel Modal */}
          <Modal
          aria-labelledby="unstyled-modal-title"
          aria-describedby="unstyled-modal-description"
          open={open}
          onClose={handleClose}
          slots={{ backdrop: StyledBackdrop }}
          >
          <ModalContent sx={{ width: 400 }}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                Hủy Đơn
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
               Bạn có thực sự muốn hủy đơn này?
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{mt:10}} spacing={2}>
              <Button variant="outlined" startIcon={<DeleteIcon />} onClick={cancelOrder}>
                Đồng Ý
              </Button>
              <Button variant="contained" endIcon={<UndoIcon />} onClick={handleClose}>
                Không
              </Button>
            </Stack>
          </ModalContent>
          </Modal>

          <Snackbar open={show} autoHideDuration={6000} onClose={() => setShow(false)}>
            <Alert onClose={() => setShow(false)} severity="success" sx={{ width: '100%' }}>
            {message}
            </Alert>
          </Snackbar>
    </div>
    
  );
}
